import { AccountGuard } from '@app/core/guards';

export type ComponentConfig = {
	moduleImport: Function;
	componentImport?: Function;
	componentName?: string;
};

export type ComponentConfigDefinition = {
	[componentKey: string]: ComponentConfig;
};

export const BrLazyComponents: ComponentConfigDefinition = {
	UtilityMenu: {
		moduleImport: () => import('@features/global-header/global-header.module'),
		componentImport: () =>
			import('@features/global-header/global-utility-header/containers/'),
		componentName: 'GlobalUtilityHeaderComponent',
	},
	HeaderMenu: {
		moduleImport: () => import('@features/global-header/global-header.module'),
		componentImport: () =>
			import('@features/global-header/global-main-header/containers/'),
		componentName: 'GlobalMainHeaderComponent',
	},
	HorizontalHeader: {
		moduleImport: () =>
			import('@features/menu-global-header/menu-global-header.module'),
		componentImport: () =>
			import('@features/menu-global-header/menu-main-header/containers/'),
		componentName: 'MenuHeaderComponentComponent',
	},
	Banner: {
		moduleImport: () => import('@features/banner/banner.module'),
		componentImport: () => import('@features/banner/containers/'),
		componentName: 'BannerComponent',
	},
	FooterMenu: {
		moduleImport: () => import('@features/global-footer/footer.module'),
		componentImport: () => import('@features/global-footer/containers/'),
		componentName: 'GlobalFooterComponent',
	},
	HorizontalFooter: {
		moduleImport: () =>
			import('@features/new-global-footer/new-global-footer.module'),
		componentImport: () => import('@features/new-global-footer/containers/'),
		componentName: 'NewGlobalFooterComponent',
	},
	PageMetadata: {
		moduleImport: () => import('@features/metadata/metadata.module'),
		componentImport: () => import('@features/metadata/containers/'),
		componentName: 'MetadataComponent',
	},
	BlogDetails: {
		moduleImport: () => import('@features/blog-detail/blog-detail.module'),
		componentImport: () => import('@features/blog-detail/containers/'),
		componentName: 'BlogDetailComponent',
	},
	Breadcrumbs: {
		moduleImport: () => import('@features/breadcrumbs/breadcrumbs.module'),
		componentImport: () => import('@features/breadcrumbs/containers/'),
		componentName: 'BreadcrumbsComponent',
	},

	BlogListing: {
		moduleImport: () => import('@features/blogs/blogs.module'),
		componentImport: () => import('@features/blogs/containers/'),
		componentName: 'ListingComponent',
	},
	TileGrid: {
		moduleImport: () => import('@features/tile-grid/tile-grid.module'),
		componentImport: () => import('@features/tile-grid/containers/'),
		componentName: 'TileGridComponent',
	},
	ImageCarousel: {
		moduleImport: () =>
			import('@features/image-carousel/image-carousel.module'),
		componentImport: () => import('@features/image-carousel/containers/'),
		componentName: 'ImageCarouselComponent',
	},
	ImageGallery: {
		moduleImport: () => import('@features/image-gallery/image-gallery.module'),
		componentImport: () => import('@features/image-gallery/containers/'),
		componentName: 'ImageGalleryComponent',
	},
	ImageList: {
		moduleImport: () => import('@features/image-list/image-list.module'),
		componentImport: () => import('@features/image-list/containers/'),
		componentName: 'ImageListComponent',
	},
	RichContent: {
		moduleImport: () => import('@features/rich-content/rich-content.module'),
		componentImport: () => import('@features/rich-content/containers/'),
		componentName: 'RichContentComponent',
	},
	TrendCollection: {
		moduleImport: () =>
			import('@features/trend-collection/trend-collection.module'),
		componentImport: () => import('@features/trend-collection/containers/'),
		componentName: 'TrendCollectionComponent',
	},
	RetailerSearchResults: {
		moduleImport: () => import('@features/find-retailer/find-retailer.module'),
		componentImport: () => import('@features/find-retailer/containers/'),
		componentName: 'FindRetailerComponent',
	},
	TabbedContent: {
		moduleImport: () =>
			import('@features/tabbed-content/tabbed-content.module'),
		componentImport: () => import('@features/tabbed-content/containers/'),
		componentName: 'TabbedContentComponent',
	},
	CategoryListing: {
		moduleImport: () =>
			import('@features/category-listing/category-listing.module'),
		componentImport: () => import('@features/category-listing/containers/'),
		componentName: 'CategoryListingComponent',
	},
	Login: {
		moduleImport: () => import('@features/login/login.module'),
		componentImport: () => import('@features/login/containers/'),
		componentName: 'LoginComponent',
	},
	CreateAccount: {
		moduleImport: () =>
			import('@features/create-account/create-account.module'),
		componentImport: () => import('@features/create-account/containers/'),
		componentName: 'CreateAccountComponent',
	},
	ForgotPassword: {
		moduleImport: () => import('@features/forgot-pwd/forgot-pwd.module'),
		componentImport: () => import('@features/forgot-pwd/containers/'),
		componentName: 'ForgotPwdComponent',
	},
	MyAccount: {
		moduleImport: () => import('@features/my-account/my-account.module'),
		componentImport: () => import('@features/my-account/containers/'),
		componentName: 'MyAccountComponent',
	},
	Card: {
		moduleImport: () => import('@features/card/card.module'),
		componentImport: () => import('@features/card/containers/'),
		componentName: 'CardComponent',
	},
	ContactUs: {
		moduleImport: () => import('@features/contact-us/contact-us.module'),
		componentImport: () => import('@features/contact-us/containers/'),
		componentName: 'ContactUsComponent',
	},
	Checkout: {
		moduleImport: () => import('@features/checkout/checkout.module'),
		componentImport: () => import('@features/checkout/containers/'),
		componentName: 'CheckoutComponent',
	},
	Cart: {
		moduleImport: () => import('@features/cart/cart.module'),
		componentImport: () => import('@features/cart/containers/'),
		componentName: 'CartComponent',
	},
	FloorFinder: {
		moduleImport: () => import('@features/floor-finder/floor-finder.module'),
		componentImport: () => import('@features/floor-finder/containers/'),
		componentName: 'FloorFinderComponent',
	},
	ProductListing: {
		moduleImport: () => import('@features/product-list/product-list.module'),
		componentImport: () => import('@features/product-list/containers/'),
		componentName: 'ProductListComponent',
	},
	ProductDetail: {
		moduleImport: () =>
			import('@features/product-detail/product-detail.module'),
		componentImport: () => import('@features/product-detail/containers/'),
		componentName: 'ProductDetailsComponent',
	},
	padding: {
		moduleImport: () => import('@features/padding/padding.module'),
		componentImport: () => import('@features/padding/contianers/'),
		componentName: 'PaddingComponent',
	},
	backToTop: {
		moduleImport: () => import('@features/back-to-top/back-to-top.module'),
		componentImport: () =>
			import('@features/back-to-top/back-to-top.component'),
		componentName: 'BackToTopComponent',
	},
	FeaturedContent: {
		moduleImport: () =>
			import('@features/featured-content/featured-content.module'),
		componentImport: () => import('@features/featured-content/containers/'),
		componentName: 'FeaturedContentComponent',
	},
	table: {
		moduleImport: () => import('@features/shop-table/shop-table.module'),
		componentImport: () => import('@features/shop-table/containers/'),
		componentName: 'ShopTableComponent',
	},
	Swatch: {
		moduleImport: () => import('@features/swatch/swatch.module'),
		componentImport: () => import('@features/swatch/containers/'),
		componentName: 'SwatchComponent',
	},
	Installation: {
		moduleImport: () => import('@features/installation/installation.module'),
		componentImport: () => import('@features/installation/containers/'),
		componentName: 'InstallationComponent',
	},
	Versus: {
		moduleImport: () => import('@features/verses/verses.module'),
		componentImport: () => import('@features/verses/containers/'),
		componentName: 'VersesCarouselComponent',
	},
	ProductFeatures: {
		moduleImport: () =>
			import('@features/product-features/product-features.module'),
		componentImport: () =>
			import('@features/product-features/container/list/list.component'),
		componentName: 'ListComponent',
	},
	VideoList: {
		moduleImport: () => import('@features/video-list/video-list.module'),
		componentImport: () =>
			import(
				'@features/video-list/container/video-listing/video-listing.component'
			),
		componentName: 'VideoListingComponent',
	},
	DetailsTable: {
		moduleImport: () => import('@features/table-listing/table-listing.module'),
		componentImport: () =>
			import(
				'@features/table-listing/containers/new-table/new-table.component'
			),
		componentName: 'NewTableComponent',
	},

	CampaignHeader: {
		moduleImport: () => import('@features/campaign-components/campaign.module'),
		componentImport: () =>
			import(
				'@features/campaign-components/campaign-header/campaign-header.component'
			),
		componentName: 'CampaignHeaderComponent',
	},
	CampaignBanner: {
		moduleImport: () => import('@features/campaign-components/campaign.module'),
		componentImport: () =>
			import(
				'@features/campaign-components/campaign-banner/campaign-banner.component'
			),
		componentName: 'CampaignBannerComponent',
	},
	CampaignBrochure: {
		moduleImport: () => import('@features/campaign-components/campaign.module'),
		componentImport: () =>
			import(
				'@features/campaign-components/campaign-brochure/campaign-brochure.component'
			),
		componentName: 'CampaignBrochureComponent',
	},
	CampaignScroller: {
		moduleImport: () => import('@features/campaign-components/campaign.module'),
		componentImport: () =>
			import(
				'@features/campaign-components/campaign-scroller/campaign-scroller.component'
			),
		componentName: 'CampaignScrollerComponent',
	},
	CampaignTwoColumn: {
		moduleImport: () => import('@features/campaign-components/campaign.module'),
		componentImport: () =>
			import(
				'@features/campaign-components/campaign-two-column/campaign-two-column.component'
			),
		componentName: 'CampaignTwoColumnComponent',
	},
	CampaignDisplay: {
		moduleImport: () => import('@features/campaign-components/campaign.module'),
		componentImport: () =>
			import(
				'@features/campaign-components/campaign-display/campaign-display.component'
			),
		componentName: 'CampaignDisplayComponent',
	},
	CampaignColorBrochure: {
		moduleImport: () => import('@features/campaign-components/campaign.module'),
		componentImport: () =>
			import(
				'@features/campaign-components/camapaign-color-brochure/camapaign-color-brochure.component'
			),
		componentName: 'CamapaignColorBrochureComponent',
	},
	ComparisonTabs: {
		moduleImport: () => import('@features/calibu-components/calibu.module'),
		componentImport: () =>
			import(
				'@features/calibu-components/comparison-tabs/comparison-tabs.component'
			),
		componentName: 'ComparisonTabsComponent',
	},
	CampaignVideo: {
		moduleImport: () => import('@features/campaign-components/campaign.module'),
		componentImport: () =>
			import(
				'@features/campaign-components/campaign-video/campaign-video.component'
			),
		componentName: 'CampaignVideoComponent',
	},
	CampaignGallery: {
		moduleImport: () => import('@features/campaign-components/campaign.module'),
		componentImport: () =>
			import(
				'@features/campaign-components/campaign-gallery/campaign-gallery.component'
			),
		componentName: 'CampaignGalleryComponent',
	},
	RetailerDetail: {
		moduleImport: () => import('@features/find-retailer/find-retailer.module'),
		componentImport: () => import('@features/find-retailer/containers/'),
		componentName: 'RetailerDetailsComponent',
	},
	CampaignFooter: {
		moduleImport: () => import('@features/campaign-components/campaign.module'),
		componentImport: () =>
			import(
				'@features/campaign-components/campaign-footer/campaign-footer.component'
			),
		componentName: 'CampaignFooterComponent',
	},
	roomvoLauncher: {
		moduleImport: () => import('@features/roomvo-launcher/roomvo.module'),
		componentImport: () =>
			import('@features/roomvo-launcher/roomvo-launcher.component'),
		componentName: 'RoomvoLauncherComponent',
	},
	roomvoListener: {
		moduleImport: () => import('@features/roomvo-listener/roomvo.module'),
		componentImport: () =>
			import('@features/roomvo-listener/roomvo-listener.component'),
		componentName: 'RoomvoListenerComponent',
	},
	OffsetBrochure: {
		moduleImport: () =>
			import('@features/offset-brochure/offset-brochure.module'),
		componentImport: () => import('@features/offset-brochure/containers/'),
		componentName: 'OffsetBrochureComponent',
	},
	OverlayedSide: {
		moduleImport: () =>
			import('@features/overlayed-side/overlayed-side.module'),
		componentImport: () => import('@features/overlayed-side/containers'),
		componentName: 'OverlayedSideComponent',
	},
	Coupon: {
		moduleImport: () => import('@features/coupon/coupon.module'),
		componentImport: () =>
			import('@features/coupon/containers/coupon/coupon.component'),
		componentName: 'CouponComponent',
	},
	Text: {
		moduleImport: () => import('@features/text/text.module'),
		componentImport: () =>
			import('@features/text/containers/text/text.component'),
		componentName: 'TextComponent',
	},
	ProductPixel: {
		moduleImport: () => import('@features/product-pixel/product-pixel.module'),
		componentImport: () =>
			import('@features/product-pixel/product-pixel.component'),
		componentName: 'ProductPixelComponent',
	},
	ProductIndex: {
		moduleImport: () => import('@features/product-index/product-index.module'),
		componentImport: () =>
			import('@features/product-index/product-index.component'),
		componentName: 'ProductIndexComponent',
	},
	stepContent: {
		moduleImport: () =>
			import(
				'@app/features/step-content/containers/step-content/step-content.module'
			),
		componentImport: () =>
			import(
				'@features/step-content/containers/step-content/step-content.component'
			),
		componentName: 'StepContentComponent',
	},
	logoCarousel: {
		moduleImport: () =>
			import('@app/features/logo-carousel/logo-carousel.module'),
		componentImport: () =>
			import(
				'@features/logo-carousel/containers/logo-carousel/logo-carousel.component'
			),
		componentName: 'LogoCarouselComponent',
	},
	flooringCard: {
		moduleImport: () =>
			import('@app/features/flooring-card/flooring-card.module'),
		componentImport: () =>
			import(
				'@features/flooring-card/containers/flooring-card/flooring-card.component'
			),
		componentName: 'FlooringCardComponent',
	},
	brochureCard: {
		moduleImport: () =>
			import('@app/features/brochure-card/brochure-card.module'),
		componentImport: () =>
			import(
				'@features/brochure-card/containers/brochure-card/brochure-card.component'
			),
		componentName: 'BrochureCardComponent',
	},
	CarouselBanner: {
		moduleImport: () =>
			import('@app/features/carousel-banner/carousel-banner.module'),
		componentImport: () =>
			import(
				'@features/carousel-banner/containers/carousel-banner/carousel-banner.component'
			),
		componentName: 'CarouselBannerWithControlComponent',
	},
	MultiColumn: {
		moduleImport: () =>
			import('@app/features/multi-column/multi-column.module'),
		componentImport: () =>
			import(
				'@features/multi-column/containers/multi-column/multi-column.component'
			),
		componentName: 'MultiColumnComponent',
	},
	ImageBanner: {
		moduleImport: () =>
			import('@app/features/image-banner/image-banner-module'),
		componentImport: () =>
			import('@features/image-banner/container/image-banner/image-banner'),
		componentName: 'ImageBanner',
	},
	ResetPassword: {
		moduleImport: () =>
			import('@features/reset-password/reset-password.module'),
		componentImport: () => import('@features/reset-password/containers/'),
		componentName: 'ResetPasswordComponent',
	},
	Band: {
		moduleImport: () => import('@features/band/band.module'),
		componentImport: () => import('@features/band/containers'),
		componentName: 'BandComponent',
	},
	Stack: {
		moduleImport: () => import('@features/stacked/stacked.module'),
		componentImport: () => import('@features/stacked/containers/'),
		componentName: 'StackedComponent',
	},
	Guide: {
		moduleImport: () => import('@features/guide/guide.module'),
		componentImport: () => import('@features/guide/containers'),
		componentName: 'GuideComponent',
	},
	Brochure: {
		moduleImport: () => import('@features/brochure/brochure.module'),
		componentImport: () => import('@features/brochure/containers/'),
		componentName: 'BrochureComponent',
	},
	Testimonial: {
		moduleImport: () => import('@features/testimonial/testimonial.module'),
		componentImport: () => import('@features/testimonial/containers/'),
		componentName: 'TestimonialComponent',
	},
	QuickLinks: {
		moduleImport: () => import('@features/quick-links/quick-links.module'),
		componentImport: () => import('@features/quick-links/containers/'),
		componentName: 'QuickLinksComponent',
	},
	multiDocuments: {
		moduleImport: () =>
			import('@features/multi-documents/multi-documents.module'),
		componentImport: () =>
			import('@features/multi-documents/containers/'),
		componentName: 'MultiDocumentsComponent',
	},
	bazaarvoice: {
		moduleImport: () => import('@features/testimonial/testimonial.module'),
		componentImport: () => import('@features/testimonial/containers/'),
		componentName: 'TestimonialComponent',
	},
	FeaturesDisplay: {
        moduleImport: () => import('@features/brxm-features-display/brxm-features-display.module'),
        componentImport: () => import('@features/brxm-features-display/brxm-features-display.component'),
        componentName: 'BrxmFeaturesDisplayComponent',
    }
};
